import { useState } from 'react';
import { useRouter } from 'next/router';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { USER_LOGIN_ROUTE } from '~/src/constants/routes';
import { useAnalytics } from '~/src/features/full-buy/analytics/context';

export const HasAgreementPopup = (): JSX.Element => {
    const analytics = useAnalytics();

    const router = useRouter();

    const [isOpen, changePopupState] = useState(false);

    const goToLk = () => {
        router.push(USER_LOGIN_ROUTE);
        changePopupState(false);
        analytics.address.popupAddressAgreement('click_enter_lk');
    };

    const handleClosePopup = () => {
        changePopupState(false);
        analytics.address.popupAddressAgreement('click_create_agreement');
    };

    const handleOpenPopup = () => {
        changePopupState(true);
        analytics.address.popupAddressAgreement('view_popup');
    };

    return (
        <>
            <Paragraph4>
                Проверим техническую возможность подключить тариф. <ControlElement Icon={InfoCircleFlip} onClick={handleOpenPopup}>Уже подключали Дом.ру?</ControlElement>
            </Paragraph4>

            <DefaultPopup isOpen={isOpen} onClose={handleClosePopup}>
                <IndentContainer $desktop={[32]} $mobile={[24]}>
                    <TextWrapper>
                        <H3>Уже подключали Дом.ру?</H3>
                        <Paragraph4 $color={COLORS.TextInfo}>
                            Чтобы не&nbsp;создавать новый договор, вы&nbsp;можете войти в&nbsp;личный кабинет и&nbsp;поменять тариф на&nbsp;более подходящий.
                        </Paragraph4>
                    </TextWrapper>

                    <ButtonGroup>
                        <Button bType={'action'} onClick={goToLk}>Войти в личный кабинет</Button>
                        <Button bType={'secondary'} onClick={handleClosePopup}>Создать новую заявку</Button>
                    </ButtonGroup>
                </IndentContainer>
            </DefaultPopup>
        </>
    );
};
